import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { UIService } from '@services';
import {
  ExtendedParametersTabsEnum,
  RemoteDiagnosticsStore,
  RemoteDiagnosticsUseCasesStore,
} from '@store';

@Component({
  selector: 'app-extended-parameters-tab',
  templateUrl: './extended-parameters-tab.component.html',
  styleUrls: ['./extended-parameters-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendedParametersTabComponent implements OnInit {
  selectedExtendedParametersTab$: Observable<ExtendedParametersTabsEnum>;

  @Input() title: string;
  @Input() extendedParametersTab: ExtendedParametersTabsEnum;
  @Input() gatewaySerial: string;

  public readonly extendedParametersTabsEnum = ExtendedParametersTabsEnum;

  constructor(
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private remoteDiagnosticsUseCasesStore: RemoteDiagnosticsUseCasesStore,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.selectedExtendedParametersTab$ = this.remoteDiagnosticsUseCasesStore.getSelectedExtendedParametersTab(
      this.gatewaySerial
    );
  }

  closePopup(): void {
    this.remoteDiagnosticsStore.saveConfirmPopupFlag();
  }

  onTabSelect(): void {
    this.remoteDiagnosticsUseCasesStore.changeExtendedParametersTab(
      this.extendedParametersTab,
      this.gatewaySerial
    );
    this.uiService.isAnyParameterRunning$.next(false);
  }
}
